import styled from '@emotion/styled';
import Container from '@ep/components/Container';
import { H3 } from '@ep/components/Typography';
import SharedSideBarModule from '@ep/modules/SharedSideBarModule';
import theme from '@ep/theme';
import { Gcms_SharedSideBar } from '@ep/types/gatsbyTypes';
import React from 'react';

export interface AsideModuleProps {
  heading?: string;
  main?: React.ReactNode;
  aside?: React.ReactNode;
  sidebars?: Gcms_SharedSideBar[];
}

const StyledContainer = styled(Container)`
  padding: 1rem 0 1rem;

  ${theme.mediaQueries.tablet} {
    padding: 2rem 0 1rem;
  }

  ${theme.mediaQueries.mobile} {
    padding: 2rem 0 1rem;
  }
`;

const Heading = styled(H3.withComponent('h1'))`
  margin-top: 3rem;
  margin-bottom: 3.75rem;

  ${theme.mediaQueries.tablet} {
    margin-bottom: 3rem;
  }

  ${theme.mediaQueries.mobile} {
    margin-bottom: 2.5rem;
  }
`;

const Content = styled.div`
  display: flex;

  strong {
    font-family: ${theme.typography.boldFont};
    font-weight: bold;
  }

  ${theme.mediaQueries.mobileAndTablet} {
    flex-direction: column;
  }
`;

const Main = styled.div`
  flex: 2;

  img {
    width: 100%;
    height: auto;
  }
`;

const RightSideContainer = styled.div`
  flex: 1;

  ${theme.mediaQueries.desktop} {
    margin-left: 2rem;
  }

  ${theme.mediaQueries.mobileAndTablet} {
    margin-top: 2rem;
  }
`;

function AsideModule({
  heading,
  main,
  aside,
  sidebars,
  ...rest
}: AsideModuleProps) {
  return (
    <StyledContainer {...rest}>
      {heading && <Heading>{heading}</Heading>}
      <Content>
        {main && <Main>{main}</Main>}
        {(aside || (sidebars && sidebars.length > 0)) && (
          <RightSideContainer>
            {sidebars && sidebars.length > 0 && (
              <SharedSideBarModule sidebars={sidebars} />
            )}
            {aside && <div>{aside}</div>}
          </RightSideContainer>
        )}
      </Content>
    </StyledContainer>
  );
}

export default AsideModule;
